import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { useQuery } from "@tanstack/react-query";

interface useGovermentAllocationEntriesNotCompletedProps<T> {
  filters: {
    search?: string;
    page: number;
    companyId?: string
    branchId?: string
  };
  mapper?: (data: any) => T,
}

export const useGovernmentAllocationEntriesNotCompleted = <T,>({
  mapper = Mapper.default<T>(),
  filters: { search = '', page, companyId, branchId }
}: useGovermentAllocationEntriesNotCompletedProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['governmentAllocationEntriesNotCompleted', search, page, companyId, branchId],
    queryFn: async () => {
      return await privateAxios.get('/billing/government_allocation_entries/not_completed', {
        params: {
          search,
          page,
          'q[company_id_eq]': companyId,
          'q[branch_id_eq]': branchId
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
  });

  return {
    data,
    meta,
    isPending,
    ...rest
  };
};
